var map = {
	".": 18992,
	"./": 18992,
	"./DailyMotion": 12146,
	"./DailyMotion.js": 12146,
	"./Facebook": 48945,
	"./Facebook.js": 48945,
	"./FilePlayer": 71638,
	"./FilePlayer.js": 71638,
	"./Kaltura": 22755,
	"./Kaltura.js": 22755,
	"./Mixcloud": 7579,
	"./Mixcloud.js": 7579,
	"./Mux": 73407,
	"./Mux.js": 73407,
	"./SoundCloud": 67229,
	"./SoundCloud.js": 67229,
	"./Streamable": 79417,
	"./Streamable.js": 79417,
	"./Twitch": 72733,
	"./Twitch.js": 72733,
	"./Vidyard": 82764,
	"./Vidyard.js": 82764,
	"./Vimeo": 49282,
	"./Vimeo.js": 49282,
	"./Wistia": 30931,
	"./Wistia.js": 30931,
	"./YouTube": 22234,
	"./YouTube.js": 22234,
	"./index": 18992,
	"./index.js": 18992,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players": 18992,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/": 18992,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion": 12146,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/DailyMotion.js": 12146,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook": 48945,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Facebook.js": 48945,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer": 71638,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/FilePlayer.js": 71638,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura": 22755,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Kaltura.js": 22755,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud": 7579,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mixcloud.js": 7579,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux": 73407,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Mux.js": 73407,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud": 67229,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/SoundCloud.js": 67229,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable": 79417,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Streamable.js": 79417,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch": 72733,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Twitch.js": 72733,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard": 82764,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vidyard.js": 82764,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo": 49282,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Vimeo.js": 49282,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia": 30931,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/Wistia.js": 30931,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube": 22234,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/YouTube.js": 22234,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index": 18992,
	".pnpm/react-player@2.16.0_react@17.0.2/node_modules/react-player/lazy/players/index.js": 18992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85456;